import { useState } from "react";
import { MdInfo } from "react-icons/md";
import { PageContent, PageHeader, PageShell } from "../../components/layout/PageShell";
import { FieldGroup, Input, Textarea } from "../../components/ui";
import { COLORS, RADIUS } from "../../shared/theme";

export default function PageConfigDroits({ processusDroits, setProcessusDroits, personnes, onBack, habColor }) {
  const [form, setForm] = useState(processusDroits);
  const set = k => e => setForm(f => ({ ...f, [k]: e.target.value }));
  const setCheck = k => e => setForm(f => ({ ...f, [k]: e.target.checked }));
  const toggleValidateur = id =>
    setForm(f => ({
      ...f,
      validateurs: f.validateurs.includes(id) ? f.validateurs.filter(v => v !== id) : [...f.validateurs, id],
    }));

  const save = () => {
    setProcessusDroits(form);
    if (onBack) onBack();
  };

  return (
    <PageShell>
      <PageHeader
        title="Configuration — Processus Droits des personnes"
        subtitle="Paramétrage du workflow interne de traitement des demandes RGPD"
      />

      <PageContent>
        <div style={{ background: COLORS.white, borderRadius: RADIUS.xl, border: `1.5px solid ${COLORS.border}`, padding: 24, marginBottom: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <div style={{ fontWeight: 800, fontSize: 14, color: COLORS.textPrimary, marginBottom: 16 }}>Paramètres du processus</div>

          {/* Toggle conformité */}
          <div style={{ marginBottom: 20 }}>
            <label style={{ display: "flex", gap: 10, cursor: "pointer", alignItems: "flex-start" }}>
              <input type="checkbox" checked={form.conforme} onChange={setCheck("conforme")} style={{ marginTop: 2 }} />
              <div>
                <div style={{ fontSize: 13, fontWeight: 700, color: form.conforme ? "#15803d" : "#92400e", marginBottom: 2 }}>
                  {form.conforme ? "Processus d'exercice des droits en place" : "Processus à configurer"}
                </div>
                <div style={{ fontSize: 12, color: form.conforme ? "#15803d" : "#92400e" }}>
                  En cochant cette case, vous attestez que votre organisation dispose d'un processus documenté pour traiter les demandes d'exercice de droits (accès, rectification, effacement, etc.) dans le délai légal de 30 jours.
                </div>
              </div>
            </label>
          </div>

          {/* Workflow */}
          <div style={{ marginBottom: 20 }}>
            <FieldGroup label="Description du workflow">
              <Textarea value={form.workflow} onChange={set("workflow")} rows={5} placeholder={"Décrivez votre processus étape par étape :\n\n1. Réception de la demande (email dpo@...)\n2. Vérification de l'identité du demandeur\n3. Transmission au service concerné\n4. Traitement dans les 30 jours\n5. Envoi de la réponse par email sécurisé\n6. Archivage de la demande"} />
            </FieldGroup>
            <div style={{ fontSize: 11, color: COLORS.textSecondary, marginTop: 4 }}>Décrivez les étapes, les responsabilités, les outils utilisés (email, formulaire, logiciel...)</div>
          </div>

          {/* Validateurs */}
          <div style={{ marginBottom: 20 }}>
            <FieldGroup label="Profils validateurs (2-3 personnes recommandées)">
              <div style={{ display: "flex", flexDirection: "column", gap: 8, marginTop: 8 }}>
                {personnes.map(p => {
                  const selected = form.validateurs.includes(p.id);
                  const hc = habColor[p.habilitation] || habColor.Autre;
                  return (
                    <div key={p.id} onClick={() => toggleValidateur(p.id)} style={{ padding: "12px 16px", borderRadius: RADIUS.md, border: `1.5px solid ${selected ? "#6ee7b7" : COLORS.border}`, background: selected ? "#f0fdf4" : COLORS.white, cursor: "pointer", display: "flex", alignItems: "center", gap: 12, transition: "all 0.15s" }}>
                      <div style={{ width: 28, height: 28, borderRadius: "50%", background: hc.bg, border: `1.5px solid ${hc.border}`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 11, fontWeight: 800, color: hc.text }}>{p.prenom[0]}{p.nom[0]}</div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.textPrimary }}>{p.prenom} {p.nom}</div>
                        <div style={{ fontSize: 11, color: COLORS.textSecondary }}>{p.habilitation} • {p.email}</div>
                      </div>
                      {selected && <div style={{ fontSize: 18, color: "#10b981" }}>✓</div>}
                    </div>
                  );
                })}
              </div>
            </FieldGroup>
            <div style={{ fontSize: 11, color: COLORS.textSecondary, marginTop: 4 }}>Sélectionnez les personnes habilitées à valider les réponses aux demandes d'exercice de droits</div>
          </div>

          {/* Email de confirmation */}
          <div style={{ marginBottom: 20 }}>
            <FieldGroup label="Email de confirmation">
              <Input type="email" value={form.emailConfirmation} onChange={set("emailConfirmation")} placeholder="dpo@votreentreprise.com" />
            </FieldGroup>
            <div style={{ fontSize: 11, color: COLORS.textSecondary, marginTop: 4 }}>Adresse email utilisée pour envoyer les confirmations de traitement aux personnes concernées</div>
          </div>

          {/* Boutons */}
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8, marginTop: 24, paddingTop: 20, borderTop: `1px solid ${COLORS.border}` }}>
            {onBack && <button onClick={onBack} style={{ padding: "9px 18px", borderRadius: RADIUS.md, border: `1.5px solid ${COLORS.border}`, background: COLORS.white, color: COLORS.textSecondary, fontSize: 13, fontWeight: 700, cursor: "pointer" }}>Annuler</button>}
            <button onClick={save} disabled={!form.conforme || !form.workflow || form.validateurs.length === 0 || !form.emailConfirmation} style={{ padding: "9px 18px", borderRadius: RADIUS.md, border: "none", background: form.conforme && form.workflow && form.validateurs.length > 0 && form.emailConfirmation ? "#0ea5e9" : "#d1d5db", color: COLORS.white, fontSize: 13, fontWeight: 700, cursor: form.conforme && form.workflow && form.validateurs.length > 0 && form.emailConfirmation ? "pointer" : "not-allowed" }}>
              Enregistrer la configuration
            </button>
          </div>

          {/* Helper message */}
          {(!form.conforme || !form.workflow || form.validateurs.length === 0 || !form.emailConfirmation) && (
            <div style={{ marginTop: 12, padding: "10px 14px", background: "#fef3c7", borderRadius: RADIUS.md, border: "1px solid #fcd34d", fontSize: 12, color: "#92400e" }}>
              <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}><MdInfo size={14} /> Pour valider, vous devez : cocher "Processus en place", décrire le workflow, sélectionner au moins 1 validateur et renseigner un email.</span>
            </div>
          )}
        </div>
      </PageContent>
    </PageShell>
  );
}
